import React from 'react';
import {
  Typography,
  Box,
  Card,
  CardContent
} from '@mui/material';
import { ContentCardProps } from './types';
import { useMediaHandler } from './MediaHandler';
import { PlatformRenderer } from './PlatformRenderer';

// Export types and utility functions for external use
export * from './types';
export { formatNumber, getInitials } from './SocialMediaPost';
export { getPlatformIcon, getPlatformStyle } from './PlatformRenderer';
export { useMediaHandler, SocialMediaImage } from './MediaHandler';

const ContentCard: React.FC<ContentCardProps> = ({ 
  content, 
  platform,
  sender,
  imageFile,
  imageUrl,
  imageDescription,
  titleComponent,
  replies7d,
  likes7d
}) => {
  // Process media data using the MediaHandler hook
  const { displayImageUrl, altText, notableDeviations } = useMediaHandler({
    imageFile,
    imageUrl,
    imageDescription
  });

  return (
    <Card elevation={3} sx={{ maxWidth: '100%' }}>
      <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
        {titleComponent ? (
          <Box sx={{ mb: 2 }}>
            {titleComponent}
          </Box>
        ) : (
          <Typography variant="h5" gutterBottom sx={{ mb: 2 }}>
            Your Content
          </Typography>
        )}
        
        <Box
          sx={{
            // In dark mode, coerce embedded platform posts to a dark surface
            // without changing platform-specific structure.
            ...(theme => ({
              ...(theme.palette.mode === 'dark'
                ? {
                    '& .MuiPaper-root': {
                      backgroundColor: '#0f1720',
                      borderColor: 'rgba(255,255,255,0.06)',
                      color: theme.palette.text.primary,
                    },
                    '& .MuiTypography-root': {
                      color: theme.palette.text.primary,
                    },
                    '& svg': {
                      color: theme.palette.text.secondary,
                    },
                  }
                : {})
            }))
          }}
        >
          <PlatformRenderer
            platform={platform || 'twitter'}
            content={content}
            sender={sender}
            displayImageUrl={displayImageUrl}
            altText={altText}
            notableDeviations={notableDeviations}
            replies7d={replies7d}
            likes7d={likes7d}
          />
        </Box>
      </CardContent>
    </Card>
  );
};

export default ContentCard;
